<template>
  <div class="bg">
    <div class="success">
      <div class="successImg">
        <div class="tick">
          <div class="successText">已取消</div>
        </div>
      </div>
    </div>
    <div class="meetingInfo">
      <div class="meetingName">
        <div class="classify">会议室：{{ orderDetail.meetname }}</div>
        <div class="classify">会议名称：{{ orderDetail.theme }}</div>
        <div class="classify">参会人：{{ attendeeName }}</div>
      </div>
      <div class="meetingTime">
        <div class="time">
          会议时间：{{ meetingDate }}({{ weekday }}) {{ startTime }}-{{
            endTime
          }}
        </div>
        <div class="time">预定人：{{ orderDetail.appointmenter }}</div>
      </div>
    </div>
    <div class="complete">
      <div class="comButton" @click="comHandle">
        <div class="comText">完成</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      weekday: "",
      meetingDate: "",
      startTime: "",
      endTime: "",
      orderDetail: {},
      attendeeName: "",
      attendees: [],
      meetingId: ""
    };
  },
  created() {
    console.log(this.$route.query.detail[0]);
    this.orderDetail = this.$route.query.detail[0];
    this.meetingDate = moment(new Date(this.orderDetail.startTime)).format(
      "YYYY-MM-DD"
    );
    this.weekday = this.initweekday(this.meetingDate);
    this.startTime = moment(new Date(this.orderDetail.startTime)).format(
      "HH:mm"
    );
    this.endTime = moment(new Date(this.orderDetail.endTime)).format("HH:mm");
    this.meetingId = this.$route.query.detail[0].meetingId;
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingName = this.$route.query.meetingName;
    this.attendeeName = this.$route.query.attendeeName;
    console.log(this.attendees);
    // for(let i in this.attendees){
    //     this.attendeeName += this.attendees[i].attendeeName+', '
    //   }
  },
  methods: {
    // 点击完成之后跳转
    comHandle() {
      this.$router.push({
        path: "/",
        query: {
          equipmentName: this.equipmentName,
          meetingId: this.meetingId,
          meetingName: this.name
        }
      });
    },
    initweekday(date) {
      console.log(date);
      switch (new Date(date).getDay()) {
        case 0:
          return "星期日";
          break;
        case 1:
          return "星期一";
          break;
        case 2:
          return "星期二";
          break;
        case 3:
          return "星期三";
          break;
        case 4:
          return "星期四";
          break;
        case 5:
          return "星期五";
          break;
        case 6:
          return "星期六";
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  background: url(../assets/delay-bg.png);
  .success {
    width: 13%;
    height: 50%;
    margin: 0 auto;
    .successImg {
      width: 240px;
      height: 240px;
      background: url(../assets/delay-yuan.png) no-repeat;
      position: relative;
      top: 25%;
      .tick {
        width: 100%;
        height: 100%;
        background: url(../assets/delay-gou.png) no-repeat;
        position: relative;
        top: 24%;
        left: 30%;
        .successText {
          font-size: 36px;
          color: #fff000;
          font-family: SimHei;
          font-weight: bold;
          background: linear-gradient(0deg, #1cf7e9 0%, #2ad8ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          position: relative;
          top: 35%;
          right: 2%;
        }
      }
    }
  }
  .meetingInfo {
    width: 100%;
    height: 35%;
    display: flex;
    .meetingName {
      width: 50%;
      height: 45%;
      .classify {
        width: 50%;
        height: 76%;
        text-align: left;
        font-size: 30px;
        color: #666666;
        font-family: SimHei;
        font-weight: 400;
        margin: 0 auto;
      }
    }
    .meetingTime {
      width: 50%;
      height: 45%;
      .time {
        width: 100%;
        height: 76%;
        text-align: left;
        font-size: 30px;
        color: #666666;
        font-family: SimHei;
        font-weight: 400;
      }
    }
  }
  .complete {
    width: 35%;
    height: 15%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    .comButton {
      width: 234px;
      height: 80px;
      background: linear-gradient(0deg, #1bf7e9, #2ad7ff);
      border-radius: 4px;
      .comText {
        font-size: 30px;
        color: #ffffff;
        text-align: center;
        line-height: 80px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cancel.vue